import React, { useEffect } from 'react';
import { Card, CardBody, CardFooter, CardHeader, Col, Row, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getFuelTankListByEstablishment } from '../../../../../slices/thunks';

const FuelStorage = ({ id }) => {
    const dispatch = useDispatch();

    const selectorFuelTank = createSelector(
        state => state.FuelTank,
        data => ({
            fuelTankList: data.fuelTankList,
            isLoadingList: data.isLoadingList,
            isFuelTankSuccess: data.isFuelTankSuccess,
        })
    );

    const { fuelTankList, isLoadingList } = useSelector(selectorFuelTank);

    useEffect(() => {
        dispatch(getFuelTankListByEstablishment(id));
    }, [id]);

    const getStockColor = (stockPercentage) => {
        if (stockPercentage > 60) {
            return 'var(--vz-success)';
        } else if (stockPercentage > 30) {
            return 'var(--vz-warning)';
        } else {
            return 'var(--vz-danger)';
        }
    };

    if (!fuelTankList || fuelTankList.length === 0) {
        return (
            <Card style={{ height: "100%" }}>
                <CardHeader className='p-2 align-items-center d-flex'>
                    <h5 className="card-title mb-0 flex-grow-1">Saldo Combustible</h5>
                </CardHeader>
                <CardBody className='p-2'>
                    <div className="d-flex justify-content-center align-items-center p-3">
                        <div className="text-center">
                            <div className="avatar-md">
                                <span className="avatar-title bg-info-subtle rounded-circle fs-1">
                                    <i className={`${Icons.fuel} text-info`}></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <p className="fs-11 lh-base text-center">No cuenta con Estanque de Combustible</p>
                </CardBody>
            </Card>
        );
    }

    return (
        <Card style={{ height: "100%" }}>
            <CardHeader className='p-2 align-items-center d-flex'>
                <h5 className="card-title mb-0 flex-grow-1">Saldo Combustible</h5>
            </CardHeader>
            <CardBody className='p-2'>
                <Row className="m-0 p-0">
                    {fuelTankList.map((tank, index) => {
                        const stockPercentage = (tank.stock / tank.capacity) * 100;
                        const stockColor = getStockColor(stockPercentage);
                        const stockStyle = {
                            height: `${stockPercentage}%`,
                            backgroundColor: stockColor,
                            transition: "height 2s",
                        };

                        return (
                            <Col
                                key={index}
                                className="text-center fuel-tank-container"
                                style={{ minWidth: "80px", padding: "6px" }}
                            >
                                <p className="fs-11 m-0">{tank.stock} Lts</p>
                                <div className="fuel-tank">
                                    <div className="fuel-tank-bar" style={stockStyle}></div>
                                </div>
                                <p className="fs-11 m-0">{tank.name}</p>
                                <p className="fs-11 m-0">{tank.projected_duration_in_weeks} semanas</p>
                            </Col>
                        );
                    })}
                </Row>
            </CardBody>
        </Card>
    );
};

export default FuelStorage;
